module.exports = __webpack_public_path__ + "img/round-tune-24px.d210aa85.svg";